import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { Link } from 'react-router-dom';


function CaseTagsReportForm() {
  const [selectedTags, setSelectedTags] = useState([]);
  const [format, setFormat] = useState('');

  const tagOptions = [
    { value: 'none', label: 'none' },
    { value: 'primescan', label: 'primescan' },
    // Add other tags as needed
  ];

  const handleTagChange = (selectedOptions) => {
    setSelectedTags(selectedOptions);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'format') {
      setFormat(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add form submission logic here if needed
  };

  return (
    <div className=" mt-5">
      <h2 className="text-left mb-4" style={{ color: '#343a40' }}>Parameters</h2>
      <Form
        onSubmit={handleSubmit}
        className="p-4 border rounded shadow-sm"
        style={{
          borderTop: '5px solid #007bff',
          maxWidth: '700px',
          overflowY: 'auto',
        }}
      >
        <Form.Group as={Row} controlId="case-tags-select">
          <Form.Label column md={4} className="font-weight-bold">Case Tags</Form.Label>
          <Col md={8}>
            <Select
              isMulti
              name="tags"
              options={tagOptions}
              value={selectedTags}
              onChange={handleTagChange}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Select case tags..."
              styles={{
                control: (provided) => ({
                  ...provided,
                  borderColor: '#ced4da',
                  boxShadow: 'none',
                  '&:hover': {
                    borderColor: '#007bff',
                  },
                }),
                multiValue: (provided) => ({
                  ...provided,
                  backgroundColor: '#e9ecef',
                }),
                multiValueLabel: (provided) => ({
                  ...provided,
                  color: '#495057',
                }),
              }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="case-tags-format"  style={{  marginTop: '10px',}}>
          <Form.Label column md={4} className="font-weight-bold">
            Format <span className="text-danger">*</span>
          </Form.Label>
          <Col md={8}>
            <Form.Control
              as="select"
              name="format"
              value={format}
              onChange={handleInputChange}
              className="border-secondary"
            >
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
  <Col sm={{ span: 8, offset: 4 }}>
    <Link to="/AddTagged">
      <Button
        id="pay-per-task-submit"
        type="button"
        variant="primary"
        className="w-100 mt-2"
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
          marginTop: '10px',
        }}
      >
        Run
      </Button>
    </Link>
  </Col>
</Form.Group>
      </Form>

    </div>
  );
}

export default CaseTagsReportForm;
